<template>
  <article class="d-flex align-items-center">
    <!-- Description -->
    <section>
      <h3 class="h6 font-weight-bold" v-html="value.formatted_string || value.toString "/>

      <ul class="list-unstyled">
        <li
            v-for="service in services"
            :key="service.id"
            class="small"
        >
          {{ service.formatted_string }}
          <template v-if="service.notice || (service.info && service.info.notice)">
            |
            {{ service.notice || service.info.notice }}
          </template>
        </li>
      </ul>
    </section>

    <!-- Control Buttons -->
    <b-button-group class="ml-auto">
      <!-- Info -->
      <b-button
          v-if="$gate.allow('update', value)"
          :disabled="pending"
          :to="{name: 'projects.elements.show', params: {projectId: value.project_id, id: value.id}, query: {currentTab: 1}}"
          variant="outline-secondary"
      >
        <fa
            :spin="pending"
            :title="$t('Walls')"
            fixed-width
            icon="info"
        />
      </b-button>

      <!-- Duplicate Modal -->
      <template v-if="$gate.allow('create', value.model_name)">
        <duplicate-modal
            :api-url="`${apiUrl}/${value.id}/duplicate`"
            :value="value"
            hide-locations
            @duplicated="$emit('created')"
        >
          <template #activator="{duplicating, show}">
            <b-button
                :disabled="duplicating"
                :title="$t('Duplicate')"
                style="border-radius: 0"
                @click="show()"
            >
              <fa :spin="duplicating" fixed-width icon="copy"/>
              <span class="sr-only">{{ $t('Duplicate') }}</span>
            </b-button>
          </template>

          <template #form="data">
            <element-fields :form="data.form"/>
          </template>

          <template #options="{options}">
            <hr>

            <b-form-checkbox
                id="services"
                v-model="options.withServices"
                class="ml-3"
            >
              {{ $t('Duplicate with services') }}
            </b-form-checkbox>
          </template>
        </duplicate-modal>
      </template>

      <!-- Edit -->
      <b-button
          v-if="$gate.allow('update', value)"
          :disabled="pending"
          :title="$t('Edit {0}', [value.name])"
          :to="{name: 'projects.elements.show', params: {projectId: value.project_id, id: value.id}}"
          variant="primary"
      >
        <fa
            :spin="pending"
            icon="edit"
        />
      </b-button>

      <!-- Delete -->
      <b-button
          v-if="$gate.allow('delete', value)"
          :disabled="pending || pendingDelete || value.deleted_at"
          :title="$t('Delete {0}', [value.name])"
          variant="danger"
          @click="handleDelete"
      >
        <fa
            :spin="pending"
            icon="trash"
        />
      </b-button>


      <!-- Restore -->
      <b-button
          v-if="$gate.allow('restore', value)"
          :disabled="value.deleted_at === null"
          :title="$t('Restore {0}', [value.name])"
          variant="success"
          @click="handleRestore()"
      >
        <fa
            :spin="pendingDelete"
            icon="recycle"
        />
      </b-button>
    </b-button-group>
  </article>
</template>
<script>
import ElementForm from '@/components/elements/ElementForm';
import DuplicateModal from "@/components/DuplicateModal";
import ElementFields from "@/components/elements/ElementFields";
import Form from 'vform';

export default {
  name: 'ProjectElementsListItem',
  components: {ElementFields, DuplicateModal, ElementForm},
  props: {
    value: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      pendingDelete: false,
      showEditModal: false,
    };
  },
  computed: {
    form() {
      return new Form(this.value)
    },
    services() {
      if (!this.value.services) {
        return [];
      }
      return this.value.services.filter(service => service);
    }
  },
  methods: {
    async handleDelete() {
      if (!confirm(this.$t('Are you sure?'))) {
        return;
      }

      this.pending = true;

      try {
        await this.axios.delete(this.apiUrl + '/' + this.value.id);
        this.$emit('deleted', this.value);
      } catch (e) {
      }

      this.pending = false;
    },

    async handleRestore() {
      this.pendingDelete = true;

      try {
        const {data} = await this.axios.post(this.apiUrl + '/' + this.value.id + '/restore');
        this.$emit('input', data);
      } catch (e) {
      }

      this.pendingDelete = false;
    },
  },
};
</script>
